import React, { Fragment } from 'react';

import AccordionItem from '../custom-visual-inspection/accordion-item';
import CustomNewItem from '../custom-general/custom-new-item';
import PAUTScanPlan from '../../forms/custom-paut/pautScanPlan';

import { PDFImageProps } from '../../../utils/models';


export interface PAUTScanPlanItem {
    id: number;
    wallThickness: number;
    bevelAngle: number;
    weldBevelShape: string;
    weldCondition: string;
    scanType: string;
    materialType: string;
    arrayType: string;
    numberOfElementsUsed: number;
    calibrationBlockThickness: number;
    probeSerialNumber: string;
    wedgeSerialNumber: string;
    scanSide: string;
    scanDirection: string;
    inspectionDate: Date;
    equipmentModal: string;
    equipmentSerialNumber: string;
    equipmentCalibrationDueDate: Date;
    waveType: string;
    referenceDB: number;
    scanAngle: number;
    images: PDFImageProps[];
}

interface Props {
    pautScanPlanItems: PAUTScanPlanItem[];
	onDataChange: (items: PAUTScanPlanItem[]) => void;
}

const PAUTScanPlanItems: React.FC<Props> = (props) => {
	const handleAddItem = (item: PAUTScanPlanItem) => {
        const newItem = { 
            ...item,
            id: props.pautScanPlanItems.length + 1 
        };

		props.onDataChange([...props.pautScanPlanItems, newItem]);
	};

	const handleDeleteItem = (item: PAUTScanPlanItem): void => {
		const newAnomalyItems = props.pautScanPlanItems.filter((pautItem) => pautItem.id !== item.id);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (originalItem: PAUTScanPlanItem, updatedItem: PAUTScanPlanItem): void => {
        const updatedItems = props.pautScanPlanItems.map((pautItem) => pautItem.id === originalItem.id ? updatedItem : pautItem);
		props.onDataChange(updatedItems);
	};

	return (
		<Fragment>
            <CustomNewItem label='Add New PAUT Scan Plan'>
                <PAUTScanPlan onSave={handleAddItem} />
            </CustomNewItem>

			<div className="divider my-4"></div>

            {props.pautScanPlanItems.map((pautItem) => (
                <AccordionItem key={pautItem.id} title={`#${pautItem.id}`} isActive>
                    <PAUTScanPlan
                        initialPautItem={pautItem}
                        onDeleteItem={() => handleDeleteItem(pautItem)}
                        onSave={(updatedItem: PAUTScanPlanItem) => handleEditItem(pautItem, updatedItem)} 
                    />
                </AccordionItem>
            ))}
		</Fragment>
	);
};

export default PAUTScanPlanItems;